import { createAction } from '../../utils';

export const FETCH_GROUP_ORDER_REQUEST = 'FETCH_GROUP_ORDER_REQUEST';
export const FETCH_GROUP_ORDER_SUCCEED = 'FETCH_GROUP_ORDER_SUCCEED';
export const FETCH_ORDER_SUMMARY_REQUESTS = 'FETCH_ORDER_SUMMARY_REQUESTS';
export const FETCH_ORDER_SUMMARY_SUCCEED = 'FETCH_ORDER_SUMMARY_SUCCEED';
export const FETCH_DELIVERY_DETAILS_SUCCEED = 'FETCH_DELIVERY_DETAILS_SUCCEED';
export const FETCH_TRACKING_EVENTS_SUCCEED = 'FETCH_TRACKING_EVENTS_SUCCEED';
export const SET_API_FINISHED = 'SET_API_FINISHED';
export const SET_API_FAILED = 'SET_API_FAILED';
export const FETCH_ORDER_TRACKER_REQUESTS = 'FETCH_ORDER_TRACKER_REQUESTS';
export const FETCH_AEM_SUMMARY_PAGE_PROPS_REQUESTS = 'FETCH_AEM_SUMMARY_PAGE_PROPS_REQUESTS';

// Amend Appointment action types
export const FETCH_ORDER_PREAPPOINTMENTS_REQUEST = 'FETCH_ORDER_PREAPPOINTMENTS_REQUEST';
export const FETCH_ORDER_PREAPPOINTMENTS_START = 'FETCH_ORDER_PREAPPOINTMENTS_START';
export const FETCH_ORDER_PREAPPOINTMENTS_SUCCEED = 'FETCH_ORDER_PREAPPOINTMENTS_SUCCEED';
export const FETCH_ORDER_PREAPPOINTMENTS_FAILED = 'FETCH_ORDER_PREAPPOINTMENTS_FAILED';
export const CONFIRM_AMENDS_TO_APPOINTMENT_REQUEST = 'CONFIRM_AMENDS_TO_APPOINTMENT_REQUEST';
export const CONFIRM_AMENDS_TO_APPOINTMENT_SUCCEED = 'CONFIRM_AMENDS_TO_APPOINTMENT_SUCCEED';
export const CONFIRM_AMENDS_TO_APPOINTMENT_FAILED = 'CONFIRM_AMENDS_TO_APPOINTMENT_FAILED';
export const DELETE_MILESTONE = 'DELETE_MILESTONE';
export const ADD_MILESTONE = 'ADD_MILESTONE';

export const fetchGroupOrder = createAction(FETCH_GROUP_ORDER_REQUEST);
export const fetchGroupOrderSucceed = createAction(FETCH_GROUP_ORDER_SUCCEED);
export const fetchOrderSummarySucceed = createAction(FETCH_ORDER_SUMMARY_SUCCEED);
export const fetchDeliveryDetailsSucceed = createAction(FETCH_DELIVERY_DETAILS_SUCCEED);
export const fetchTrackingEventsSucceed = createAction(FETCH_TRACKING_EVENTS_SUCCEED);
export const fetchOrderSummaryRequests = createAction(FETCH_ORDER_SUMMARY_REQUESTS);
export const fetchOrderTrackerRequests = createAction(FETCH_ORDER_TRACKER_REQUESTS);
export const getAEMSummaryPropsRequest = createAction(FETCH_AEM_SUMMARY_PAGE_PROPS_REQUESTS);
export const setAPIFinished = createAction(SET_API_FINISHED);
export const addMilestone = createAction(ADD_MILESTONE);

// Amend Appointment actions
export const fetchOrderPreAppointments = createAction(FETCH_ORDER_PREAPPOINTMENTS_REQUEST);
export const fetchOrderPreAppointmentsStart = createAction(FETCH_ORDER_PREAPPOINTMENTS_START);
export const fetchOrderPreAppointmentsSucceed = createAction(FETCH_ORDER_PREAPPOINTMENTS_SUCCEED);
export const fetchOrderPreAppointmentsFailed = createAction(FETCH_ORDER_PREAPPOINTMENTS_FAILED);
export const confirmAmendsToAppointment = createAction(CONFIRM_AMENDS_TO_APPOINTMENT_REQUEST);
export const confirmAmendsToAppointmentSucceed = createAction(CONFIRM_AMENDS_TO_APPOINTMENT_SUCCEED);
export const confirmAmendsToAppointmentFailed = createAction(CONFIRM_AMENDS_TO_APPOINTMENT_FAILED);
export const deleteMilestone = createAction(DELETE_MILESTONE);
// error actions
export const setAPIFailed = createAction(SET_API_FAILED);
